export const SUBMIT_SUPPORT_REQUEST = 'SUBMIT_SUPPORT_REQUEST'
export const SUPPORT_REQUEST_ERROR = 'SUPPORT_REQUEST_ERROR'
export const ADD_ATTACHMENT_JIRA = 'ADD_ATTACHMENT_JIRA'
export const ERROR_ATTACHMENT_JIRA = 'ERROR_ATTACHMENT_JIRA'
